import React, { useState } from 'react';
import { verifyPassword } from '../../services/authService';
import './VerifyPasswordModal.css';

const VerifyPasswordModal = ({ isOpen, onClose, onCancel, onVerified, title = "Confirm Password", message = "Please enter your password to continue." }) => {
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    if (!isOpen) return null;

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        try {
            await verifyPassword(password);
            onVerified();
            onClose();
            setPassword('');
        } catch (err) {
            setError(err.message || 'Verification failed. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content verification-modal">
                <h3>{title}</h3>
                <p>{message}</p>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <input
                            type="password"
                            placeholder="Enter password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            autoFocus
                        />
                    </div>
                    {error && <div className="error-message" style={{ marginTop: '0', marginBottom: '1rem', fontSize: '0.85rem' }}>{error}</div>}
                    <div className="modal-actions">
                        <button type="submit" className="btn-submit" disabled={loading}>
                            {loading ? 'Verifying...' : 'Verify'}
                        </button>
                        <button type="button" className="btn-cancel" onClick={onCancel || onClose} disabled={loading}>
                            Cancel
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default VerifyPasswordModal;
